import script from "./ConfigFormulario.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigFormulario.vue?vue&type=script&setup=true&lang=js"

import "./ConfigFormulario.vue?vue&type=style&index=0&id=53d52f4d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d52f4d"]])

export default __exports__